import React, { useState } from 'react';
import { QrCode } from 'lucide-react';

const Login = ({supabase}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      if (error) throw error;

// Redirect to dashboard or home
      window.location.href = '/';

      
      // Simulate successful login
      console.log('Login successful');
      // Redirect would happen here
      // window.location.href = '/dashboard';
      
    } catch (error) {
      console.error('Error logging in:', error.message);
      setErrorMessage(error.message || 'Failed to log in');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div className="max-w-md w-full space-y-8">
    <div>
    <div className="flex justify-center">
    <div className="bg-indigo-100 p-3 rounded-full">
    <QrCode className="h-12 w-12 text-indigo-600" />
    </div>
    </div>
    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Qr2Air</h2>
    <p className="mt-2 text-center text-sm text-gray-600">
    Sign in to your account
    </p>
    </div>
    
    <form className="mt-8 space-y-6" onSubmit={handleLogin}>
    <div className="rounded-md shadow-sm -space-y-px">
    <div>
    <label htmlFor="email-address" className="sr-only">Email address</label>
    <input
    id="email-address"
    name="email"
    type="email"
    autoComplete="email"
    required
    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
    placeholder="Email address"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    />
    </div>
    <div>
    <label htmlFor="password" className="sr-only">Password</label>
    <input
    id="password"
    name="password"
    type="password"
    autoComplete="current-password"
    required
    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
    placeholder="Password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    />
    </div>
    </div>

    {errorMessage && (
      <div className="text-red-500 text-sm text-center">
      {errorMessage}
      </div>
    )}

    <div className="flex items-center justify-between">
    <div className="flex items-center">
    <input
    id="remember-me"
    name="remember-me"
    type="checkbox"
    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
    />
    <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
    Remember me
    </label>
    </div>

    <div className="text-sm">
    <button type="button" className="font-medium text-indigo-600 hover:text-indigo-500 underline">
    Forgot your password?
    </button>
    </div>
    </div>

    <div>
    <button
    type="submit"
    disabled={isLoading}
    className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    >
    {isLoading ? 'Signing in...' : 'Sign in'}
    </button>
    </div>
    
    <div className="text-sm text-center">
    <span className="text-gray-600">Don't have an account?</span>{' '}
    <button type="button" className="font-medium text-indigo-600 hover:text-indigo-500 underline">
    Sign up
    </button>
    </div>
    </form>
    </div>
    </div>
    );
  };

  export default Login;